// extracted by mini-css-extract-plugin
export default {"OrganisationListAlert":"OrganisationList_OrganisationListAlert__thfeB"};